import { useEffect, useState } from "react"
import  Bindcomponent  from '../utils/bindcomponent.js';
import { useNavigate } from "react-router-dom";
import api from '../pages/AxiosFetchData.js'
import Layout from './Layout';
import {CatchWrapperAsync} from '../utils/catchwrapper.js'
import StringToReactComponent from 'string-to-react-component';
import Box from '@mui/material/Box';
 
const DynamicPage = () =>{
    const [message,setmessage] = useState('')
    const [component,setComponent] = useState('')
    const [value,setvalue] = useState('')
    const Navigate = useNavigate();
    
    useEffect(()=>{
        GetComponent();
    },[])

     const GetComponent = async () => {
        var response; 
        CatchWrapperAsync(async ()=>{
            response =  await api.get(`GetComponent/1`).refreshToken(Navigate,"productlivestock");
           
            if(response)
            { 
                console.log(response.data.value)
                 setComponent(response.data.module);
                 setvalue(response.data.value)
            }
        },setmessage)
    };

    const handleStartEndDate = (data) =>{
        //alert('hai')
    }

    const params = {}
    params.onClick =  (data) => handleStartEndDate(data)
    
    return ( 
        <>
            <Layout message={message} setmessage={setmessage}>
                  
                <div className='pd' ><b>Dynamic Page</b></div>
                <div className="pd">
                    <Box sx={{ height: "100%" }} >
                            <StringToReactComponent data={{Bindcomponent, props: params}}>
                                 {`(props)=>{
                                   ${value}
                                }`}  
                            </StringToReactComponent>
                            
                    </Box>
                </div>
              
            </Layout>
        </>
         
    )
}

export default DynamicPage